import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";

import { MedIconVolumeMidComponent } from "./med-icon-volume-mid.component";

@NgModule({
  declarations: [
    MedIconVolumeMidComponent,
  ],
  imports: [
    CommonModule,
  ],
  exports: [
    MedIconVolumeMidComponent,
  ],
})
export class MedIconVolumeMidModule { }
